import * as React from 'react';
import { observer } from 'mobx-react';
import * as d3 from 'd3';
import { IDispersionBackgroundProps } from './IDispersionBackgroundProps';
//import Axis = d3.svg.Axis;

@observer
export class DispersionBackground extends React.Component<IDispersionBackgroundProps> {
  private arrayWithTickXValues: Array<number> = [];
  private xAxis: d3.svg.Axis = d3.svg.axis();
  private yAxis: d3.svg.Axis = d3.svg.axis();
  private xTicks: NodeList;

  private renderXAxis(node: SVGGElement | null) {
    if (!node) {
      return;
    }
    d3.select(node)
      .selectAll('*')
      .remove();
    for (let i = 0; i < this.xTicks.length; i++) {
      node.appendChild(this.xTicks[i].cloneNode(true));
    }
  }

  private renderYAxis(node: SVGGElement | null) {
    if (!node) {
      return;
    }
    d3.select(node).call(this.yAxis);
  }

  private calculateXScaleTicks() {
    this.arrayWithTickXValues = [];
    const node = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const ticks = d3
      .select(node)
      .call(this.xAxis)
      .selectAll('.tick');
    ticks.each(data => this.arrayWithTickXValues.push(data));
    if (this.arrayWithTickXValues.length % 2 === 0) {
      const lastTick = ticks[0][ticks[0].length - 1] as any;
      lastTick && (lastTick.style.display = 'none');
    }
    this.xTicks = d3
      .select(node)
      .call(this.xAxis)
      .node().childNodes;
  }

  renderRings() {
    this.calculateXScaleTicks();
    const arcTicks = this.arrayWithTickXValues;
    if (arcTicks.length % 2 === 0) {
      const step = arcTicks[1] - arcTicks[0];
      arcTicks[arcTicks.length] = arcTicks[arcTicks.length - 1] + step;
    }
    return this.arrayWithTickXValues.map((tick, i) => {
      if (i > 0 && i % 2 === 0) {
        const arc = d3.svg
          .arc()
          .innerRadius(this.props.xAxisScale(arcTicks[i - 1]))
          .outerRadius(this.props.xAxisScale(arcTicks[i]))
          .startAngle(0 * (Math.PI / 180)) //converting from degs to radians
          .endAngle(180 * (Math.PI / 180));
        return (
          <path
            key={tick}
            d={(arc as any)().toString()}
            fill="#F1F1F1"
            transform={'translate(0,' + this.props.height / 2 + ')'}
            onClick={this.props.onBackgroundClick}
          >
            {' '}
          </path>
        );
      }
      return null;
    });
  }

  render() {
    const height = this.props.height;
    const width = this.props.width;
    const margin = this.props.margins;

    const outlineData = [
      { x: 0, y: 0 },
      { x: 0, y: height },
      { x: width, y: height },
      { x: width, y: 0 },
      { x: 0, y: 0 },
    ];

    const ticksCount = 10;
    const xAxisScale = this.props.xAxisScale;
    const yAxisScale = this.props.yAxisScale;

    //Create the X Axis
    this.xAxis = d3.svg
      .axis()
      .scale(xAxisScale)
      .orient('bottom');

    //Create the Y Axis
    this.yAxis = d3.svg
      .axis()
      .scale(yAxisScale)
      .orient('right')
      .tickFormat(d => Math.abs(d).toString())
      .ticks(ticksCount);

    const lineFunction: Function = d3.svg
      .line<{
        x: number;
        y: number;
      }>()
      .x(d => d.x)
      .y(d => d.y)
      .interpolate('linear');

    return (
      <div id="dispersion-view-container">
        <svg
          width={width + margin.left + margin.right}
          height={height + margin.top + margin.bottom}
        >
          <g transform={'translate(' + margin.left + ',' + margin.top + ')'}>
            <g className="background-group">
              <rect
                className="dispersion-background"
                width={width}
                height={height}
                x={0}
                y={0}
                fill="#F9F9F9"
                onClick={this.props.onBackgroundClick}
              ></rect>
              <svg className="ring-container" width={width} height={height} ref="ringContainer">
                {this.renderRings()}
              </svg>
              <path
                d={lineFunction(outlineData)}
                strokeWidth="1px"
                stroke="#c1c1c1"
                fill="none"
              ></path>
              <g
                className="x axis"
                transform={`translate(${0}, ${height / 2})`}
                ref={node => this.renderXAxis(node)}
              ></g>
              <g className="y axis" ref={node => this.renderYAxis(node)}></g>
              <line
                x1="0"
                y1={height / 2}
                x2={width}
                y2={height / 2}
                strokeWidth="2"
                stroke="#fff"
              ></line>
              {this.props.children}
            </g>
          </g>
        </svg>
      </div>
    );
  }
}
